import { View } from './view';
import { Translations } from '../config/translations';

export class StripeView extends View {

    stripeFormContainer = document.createElement('div');

    renderStripeFormFragment(splitElements: boolean = false) {
        const srtipeFormFragment = document.createDocumentFragment();
        this.stripeFormContainer.setAttribute('id', 'stripe-form-block');

        const sealsElementHtml = this.getSealsElementHtml();
        const fieldsElements = splitElements ? this.getSplitCreditCardFields() : this.getSingleCreditCardField();

        this.stripeFormContainer.innerHTML = `${fieldsElements}
                                ${sealsElementHtml}`;
        srtipeFormFragment.appendChild(this.stripeFormContainer);
        const container = this.getDFContainer();
        container.appendChild(srtipeFormFragment);
    }

    getSealsElementHtml() {
        return `<div class='seals df-payment-field'><img src='https://depositfix.s3.amazonaws.com/seal.png' style='width: 300px;' /></div>`;
    }

    getSingleCreditCardField() {
        return `<form class='hs-form stacked df-f df-f-stripe' id='df_stripe_form' action='javascript:void(0);' method='POST'>
        <fieldset class='form-columns-1 df-payment-field df-fieldset'>
            <div class='field hs-form-field df-field'>
                <label>
                    <span class='df-f-label' id='hs-card-number-label' data-label="credit_card_number">${Translations.CREDIT_CARD_NUMBER}</span><span class='hs-form-required'>*</span>
                </label>
                <div class='input hs-input stripe_elements' id='stripe_elements'></div>
            </div>
            <fieldset class='form-columns-1 df-fieldset'><label class='error' id='stripe_error'></label></fieldset>
        </fieldset>
        </form>`;
    }

    getSplitCreditCardFields() {
        return `<form class='hs-form stacked df-f df-f-stripe' id='df_stripe_form' action='javascript:void(0);' method='POST'>
        <fieldset class='form-columns-1 df-payment-field df-fieldset'>
            <div class='field hs-form-field df-field'>
                <label>
                    <span class='df-f-label' id='hs-card-number-label' data-label="credit_card_number">${Translations.CREDIT_CARD_NUMBER}</span><span class='hs-form-required'>*</span>
                </label>
                <div class='input hs-input stripe_elements' id='stripe_elements_card'></div>
            </div>
        </fieldset>
        <fieldset class='form-columns-2 df-payment-field2 df-fieldset'>
            <div class='field hs-form-field df-field'>
                <label>
                    <span class='df-f-label' id='hs-exp-date-label' data-label="exp_date">${Translations.EXP_DATE}</span><span class='hs-form-required'>*</span>
                </label>
                <div class='input hs-input stripe_elements' id='stripe_elements_exp'></div>
            </div>
            <div class='field hs-form-field df-field'>
                <label>
                    <span class='df-f-label' id='hs-cvc-label' data-label="cvc">${Translations.CVC}</span><span class='hs-form-required'>*</span>
                </label>
                <div class='input hs-input stripe_elements' id='stripe_elements_cvc'></div>
            </div>
        </fieldset>
        <fieldset class='form-columns-1 df-fieldset'><label class='error' id='stripe_error'></label></fieldset>
        </form>`;
    }

    hidePayNowButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'none';
        }
    }

    showPayNowButton() {
        const button = this.getHtmlElement('#df_buybtn');
        if (button) {
            button.style.display = 'inline-block';
            button.setAttribute('data-label', 'pay_now');
        }
    }

    setVisible(isActive: boolean) {
        const form = this.getHtmlElement('#stripe-form-block');
        if (!form) {
            return;
        }
        if (isActive) {
            this.show(form);
            this.showPayNowButton();
        } else {
            this.hide(form);
            this.hidePayNowButton();
        }
    }

    applyHubspotCss() {
        const hsInput = this.getFromHSFrame('input.hs-input[name=email]');

        const ignoreElements = ['width', 'inline-size', 'display', 'margin-right', 'margin-inline', 'margin-inline-end', 'margin-inline-start'];

        if (hsInput) {
            //const computedStyles = window.getComputedStyle(hsInput, '').cssText;

            const style = window.getComputedStyle(hsInput, '');

            let computedStyles = '';

            for (let i = 0; i < style.length; i++) {
                if (ignoreElements.indexOf(style[i]) < 0) {
                    computedStyles += style[i] + ': ' + style.getPropertyValue(style[i]) + '; ';
                }
            }

            const stripeContainers = this.getHtmlElements('.stripe_elements');
            stripeContainers.forEach(stripeContainer => {

                //stripeContainer.style.cssText = this.stripCss(computedStyles);
                stripeContainer.setAttribute('style', computedStyles);

                // Calc proper padding
                const height = hsInput.offsetHeight;
                if (height) {
                    const adjHeight = (height - 18) / 2;
                    stripeContainer.style.paddingLeft = adjHeight + 'px';
                    stripeContainer.style.paddingRight = adjHeight + 'px';
                    stripeContainer.style.paddingTop = adjHeight + 'px';
                }
            }, 'nodes');
        }
    }

    private stripCss(css: string) {
        return css.split(';')
            .filter(part => !part.trim().startsWith('width') && !part.trim().startsWith('padding'))
            .join(';');
    }

    hideStripeForm() {
        const stripeForm: any = document.querySelector('#stripe-form-block');
        if (stripeForm) {
            stripeForm.style.display = 'none';
        }
    }

    showStripeForm() {
        const stripeForm: any = document.querySelector('#stripe-form-block');
        if (stripeForm) {
            stripeForm.style.display = 'block';
        }
    }

    getTotal(): number {
        const totalChar = document.getElementById('df-final-amount');
        if (totalChar) {
            return parseInt(totalChar.innerText.replace(/^\D+/g, ''), 10) || 0;
        }
        return 0;
    }

    showForm() {
        this.stripeFormContainer.style.display = 'initial';
    }

    hideForm() {
        this.stripeFormContainer.style.display = 'none';
    }

}
